export const getErrorMessage = (error, fallback) =>
  error?.response?.data?.detail || error?.response?.data?.message || fallback;
